<div class="public-toolbar">
    @if (isLogoPending()) {
        <div class="public-toolbar-logo public-toolbar-logo--pending"></div>
    } @else {
        <logo class="public-toolbar-logo" [config]="companyLogoConfig()" surface="primary" [clickable]="false">
        </logo>
    }

    <div class="public-toolbar-info">
        @if (content(); as template) {
            <ng-container [ngTemplateOutlet]="template"></ng-container>
        }

        @if (!isAuthorized()) {
            <pnyc-button class="public-toolbar-login" [text]="'PUBLIC_TOOLBAR.TITLES.LOGIN'" [link]="'/'">
            </pnyc-button>
        }
    </div>
</div>
